import React from 'react';
import styled, { css } from 'styled-components';
import { slate3, white, slate1 } from '@engage/colors';

const BookmarkIconWithTop: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = props => (
  <svg width={28} height={28} {...props}>
    <path d="M17.981 21.91l.162-.039c.159-.08.267-.27.267-.509V6.091H9.59v15.272c0 .242.107.433.262.511.137.069.291.043.44-.081l3.671-3.708.348.346 3.381 3.359a.453.453 0 0 0 .289.121zm-4.012-2.439l-3.011 3.039c-.467.397-1.04.492-1.546.239-.502-.253-.802-.788-.802-1.387V6.08c0-.531.419-.97.948-.97h8.884c.529 0 .948.439.948.97v15.281c0 .597-.304 1.132-.807 1.385a1.337 1.337 0 0 1-.602.144c-.329 0-.65-.123-.916-.347l-.063-.059-3.033-3.014z" />
  </svg>
);

const BookmarkIconWithoutTop: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = props => (
  <svg width={28} height={28} viewBox="0 0 28 28" {...props}>
    <path
      d="M23.378 0v23.027c0 .74-.385 1.381-1.007 1.676a1.661 1.661 0 0 1-.716.162c-.391 0-1.126-.41-1.126-.41l-.06-.053-6.343-5.947-6.237 5.943c-.617.495-1.298.59-1.89.31-.617-.294-.999-.936-.999-1.68V0"
      strokeWidth={2}
      fillRule="evenodd"
    />
  </svg>
);

const createIcon = (primary: string, secondary: string) => ({
  withTop = false,
  filled = false,
}: React.SVGProps<SVGSVGElement> & { withTop?: boolean; filled?: boolean }) =>
  withTop ? (
    <StyledBookmarkIconWithTop primaryColor={primary} />
  ) : (
    <StyledBookmarkIconWithoutTop
      primaryColor={primary}
      secondaryColor={secondary}
      filled={filled}
    />
  );

// used to fix absolute or fixed positioned elements that sometimes disappear in chrome browser
// when used with sticky or relative positioned elements
// the idea came from this comment: https://stackoverflow.com/a/18764086/4855909
const chromeAbsolutePositionFix = css`
  -webkit-transform: translateZ(0);
`;

const StyledBookmarkIconWithTop = styled(({ primaryColor, ...props }) => (
  <BookmarkIconWithTop {...props} />
))<{ primaryColor: string }>`
  ${chromeAbsolutePositionFix}
  fill: ${p => p.primaryColor};
  fill-opacity: 1;
  stroke-opacity: 0;
`;

const StyledBookmarkIconWithoutTop = styled(
  ({
    primaryColor,
    secondaryColor,
    filled,
    ...props
  }: {
    primaryColor: string;
    secondaryColor: string;
    filled: boolean;
  }) => <BookmarkIconWithoutTop {...props} />,
)`
  ${chromeAbsolutePositionFix}
  stroke: ${p => p.primaryColor};
  fill: ${p => (p.filled ? p.primaryColor : p.secondaryColor)};
  fill-opacity: ${p => (p.filled ? 1 : 0.05)};
  stroke-opacity: ${p => (p.filled ? 1 : 0.7)};
`;

export const WhiteBookmarkIcon = createIcon(white, slate3);
export const BlueBookmarkIcon = createIcon(slate3, white);
export const SlateBookmarkIcon = createIcon(slate1, white);
